import { View } from 'react-native-web'
import { useState,useEffect } from 'react'
import { CardDetail, } from '../../element/Card'
import BookRoomDescription from './PgMakerComponent/BookRoom'
import { BookRoomSelect } from './PgMakerComponent/BookRoomSelect'
import { Room } from '../../List/GameBookList'
import Loader from '../../element/Loader'
import { db } from '../../firebase/FirebaseConfig';
import {collection, getDocs, query, where,} from 'firebase/firestore';
import AsyncStorage from '@react-native-async-storage/async-storage';




var a=0;
var b=0;
var c=0;
var d=0;
var e=0;
var pga=0;
var pgb=0;
var pgc=0;
var pgd=0;
var pge=0;

const GameBook = ({navigation}) => {
    const [flip, setFlip]=useState(false)
    const [Rooms, setRooms]=useState(Room[0])
    const [flip1, setFlip1]=useState(true)

    function Flip(){setFlip(!flip);}

useEffect(()=>{
  setRooms(Room[0])
  setFlip1(false)
     const Loop=async()=>{
       
      var value = await AsyncStorage.getItem('Room1');
      
      if (value !== null) {
                            let index= Room.findIndex(obj=>obj.id===value)
                            setRooms(Room[index]);
                            setFlip1(false)}
       else{
              setRooms(Room[0]);
              setFlip1(false)}} 
       Loop();},[])
   

const SaveRoom = async ({id}) => {
      try {
            await AsyncStorage.setItem(
                                        'Room1',
                                         id,);}
            catch (error) {console.log('errore salvataggio')}};
 
   
const Game =()=>{    
function pressed (item, item1){
  
    let tribu=item
    let idsucc=item1 
    console.log(idsucc)
    setFlip(!flip);
             if(tribu=='Brennen'){a=a+1;
                                  let id = idsucc;
                                  let index = Room.map(function(x) {return x.id; }).indexOf(id);
                                  setRooms(Room[index]);
                                  SaveRoom({id});
                                   }
             if(tribu=='Kumpania'){
                                   b=b+1;
                                   let id = idsucc;
                                   let index = Room.map(function(x) {return x.id; }).indexOf(id);
                                   setRooms(Room[index]);
                                   SaveRoom({id});
                                  }
             if(tribu=='Priorato di Aletheia'){c=c+1;
                                               let id = idsucc;
                                               let index = Room.map(function(x) {return x.id; }).indexOf(id);
                                               setRooms(Room[index]);
                                               SaveRoom({id});
                                               }
                                               
             if(tribu=='Popolo di Zao'){d=d+1;
                                        let id = idsucc;
                                        let index = Room.map(function(x) {return x.id; }).indexOf(id);
                                        setRooms(Room[index]);
                                        SaveRoom({id});
                                       }
             if(tribu=='Volkron'){e=e+1;
                                  let id = idsucc;
                                  let index = Room.map(function(x) {return x.id; }).indexOf(id);
                                  setRooms(Room[index]);
                                  SaveRoom({id});
                                  }
             if(tribu=='servizio'){let id = idsucc;
                                   let index = Room.map(function(x) {return x.id; }).indexOf(id);
                                   setRooms(Room[index]);
                                   SaveRoom({id});
                                  }
             if(tribu=='Result'){
                                  let id='00001a';
                                  let index = Room.map(function(x) {return x.id; }).indexOf(id);
                                  setRooms(Room[index]);
                                  setFlip1(true)
                                  SaveRoom({id})
                                  Risultato();}}
              
     
              const Risultato= async()=>{
               
                                         const corpo = [];
                                         const sensi = [];
                                         const mente = [];
                                         const vuoto = [];
                                         const forma = [];
                 
                 const corpoquery = query (collection(db, "personaggi"), where("Tribe", "==", "Brennen"), where ("Death", "==", false));
                 const sensiquery = query (collection(db, "personaggi"), where("Tribe", "==", "Kumpania"), where ("Death", "==", false));
                 const mentequery = query (collection(db, "personaggi"), where("Tribe", "==", "Priorato di Aletheia"), where ("Death", "==", false));
                 const vuotoquery = query (collection(db, "personaggi"), where("Tribe", "==", "Popolo di Zao"), where ("Death", "==", false));
                 const formaquery = query (collection(db, "personaggi"), where("Tribe", "==", "Volkron"), where ("Death", "==", false));
                
             
                 const querySnapshotcorpo = await   getDocs(corpoquery);
                 querySnapshotcorpo.forEach((docs)=>{corpo.push(docs.data().tribù);});
                 const querySnapshotsensi = await   getDocs(sensiquery);
                 querySnapshotsensi.forEach((docs)=>{sensi.push(docs.data().tribù);});
                 const querySnapshotmente = await   getDocs(mentequery);
                 querySnapshotmente.forEach((docs)=>{mente.push(docs.data().tribù);});
                 const querySnapshotvuoto = await   getDocs(vuotoquery);
                 querySnapshotvuoto.forEach((docs)=>{vuoto.push(docs.data().tribù);});
                 const querySnapshotforma = await   getDocs(formaquery);
                 querySnapshotforma.forEach((docs)=>{forma.push(docs.data().tribù);});
                
                 pga=corpo.length;
                 pgb=sensi.length;
                 pgc=mente.length;
                 pgd=vuoto.length;
                 pge=forma.length;
             
                 var ordine= [{numeroPg:pga,
                     numeroRisposte:a,
                     tribu: 'Brennen'},
                     
                     {numeroPg:pgb,  
                       numeroRisposte:b,
                       tribu: 'Kumpania'},
     
                    {numeroPg:pgc,
                     numeroRisposte:c,
                     tribu: 'Priorato di Aletheia'},
                   {numeroPg:pgd,
                    numeroRisposte:d,
                    tribu: 'Popolo di Zao'},
                   {numeroPg:pge,
                    numeroRisposte:e,
                    tribu: 'Volkron'}];
             
                    ordine.sort(function(a, b) {
                      if (a.numeroPg < b.numeroPg) {
                        return -1;
                      }
                      if (a.numeroPg > b.numeroPg) {
                        return 1;
                      }
                      if (a.numeroRisposte > b.numeroRisposte) {
                        return -1;
                      }
                      if (a.numeroRisposte < b.numeroRisposte) {
                        return 1;
                      }
                      return 0;
                    });
                 console.log(ordine)
                 var Tribi = ordine[0].tribu
                  
                  setFlip1(false);
                 navigation.navigate('Interlude', {Tribi});}

  return (
    <View style={{alignItems:'center'}}>
      <CardDetail icon1={false} icon2={true} onPress1={()=>{Flip()}} hsize={0.8} bottom={30} right={30}>
        {flip? <BookRoomSelect risA={Rooms.rispostaA} risB={Rooms.rispostaB} risC={Rooms.rispostaC} onPress={()=>{pressed(Rooms.tribuA, Rooms.idsuccA)}} onPress2={()=>{pressed(Rooms.tribuC, Rooms.idsuccC)}} onPress1={()=>{pressed(Rooms.tribuB, Rooms.idsuccB)}}></BookRoomSelect> : <BookRoomDescription item={Rooms.descrizione} title={'Preludi Notturni'} subtitle={'Capitolo 1'}/>}
      </CardDetail>  
    </View>);}

    return(
      <View style={{alignItems:'center', justifyContent:'center', width:'100%', height:'100%'}}>
        {flip1? <Loader/>:<Game/>}
      </View>
    );}

export default GameBook
